export const SET_TOGGLE_FETCHING = 'WORKOUT_PLAN:SET_TOGGLE_FETCHING';
export const SET_WORKOUT_PLAN_DATA = 'WORKOUT_PLAN:SET_WORKOUT_PLAN_DATA';
export const TOGGLE_EXERCISE = 'WORKOUT_PLAN:TOGGLE_EXERCISE';
export const SET_IS_LOADED = 'WORKOUT_PLAN:SET_IS_LOADED';
export const CLEAR_WORKOUT_PLAN = 'WORKOUT_PLAN:CLEAR_WORKOUT_PLAN';
export const ADD_ERROR = 'WORKOUT_PLAN:ADD_ERROR';
export const ADD_SIMILAR_PLANS_LOADING = 'WORKOUT_PLAN:ADD_SIMILAR_PLANS_LOADING';
export const ADD_SIMILAR_PLANS = 'WORKOUT_PLAN:ADD_SIMILAR_PLANS';
